import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faTimes,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { SearchContainer, SearchComponent } from './search-components';

type Props = {
  placeholder?: string;
  value: string;
  onChange: (e: any) => void;
  onClear?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  variant?: 'large' | 'medium' | 'small' | 'header';
  onKeyUp?: (e: any) => void;
  autoSearch?: boolean;
  isHeaderSearch?: boolean;
  submitSearch?: (e: any) => void;
};

export default function SearchNew({
  placeholder,
  value,
  onChange,
  onClear,
  disabled,
  isLoading,
  variant = 'medium',
  onKeyUp,
}: Props) {
  const clearSearch = () => {
    if (onClear) {
      onClear();
    }
  };

  return (
    <SearchContainer>
      <div className="Search-svg">
        <FontAwesomeIcon icon={faSearch} />
      </div>
      <SearchComponent
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        variant={variant}
        onKeyUp={onKeyUp}
      />
      {value && (
        <div className="Cross-svg" onClick={clearSearch}>
          <FontAwesomeIcon icon={isLoading ? faSpinner : faTimes} />
        </div>
      )}
    </SearchContainer>
  );
}
